import { render, staticRenderFns } from "./edit-refer-case.vue?vue&type=template&id=6226d4d3&scoped=true&"
import script from "./edit-refer-case.vue?vue&type=script&lang=js&"
export * from "./edit-refer-case.vue?vue&type=script&lang=js&"
import style0 from "./edit-refer-case.vue?vue&type=style&index=0&id=6226d4d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6226d4d3",
  null
  
)

export default component.exports